<!-- 咨询师 -->
<template>
  <div class="container">
    <div class="header" :height="bannerHeight + 'px'"></div>
    <div class="postionContainer">
      <!-- 协议页面  采集协议collectProtocol -->
      <div class="collectProtocol" v-if="operation1">
        <!-- <el-scrollbar> -->
        <div class="infinite-list">
          <!-- <div class="protocolTitle">协议</div> -->
          <div style="text-align: left; font-size: 14px" class="protocolContent">
            <h1 style="
                margin-top: 23px;
                margin-right: 0;
                margin-bottom: 22px;
                margin-left: 0;
                text-align: center;
                line-height: 240%;
                page-break-after: avoid;
              ">
              <span style="font-size: 29px; line-height: 240%">资质申请服务协议</span>
            </h1>
            <p style="text-align: center">
              <span style="font-size: 13px">&nbsp;</span>
            </p>
            <p style="text-align: center">
              <span style="font-family: 宋体">版本生效日期：</span>2023<span style="font-family: 宋体">年【</span>06<span
                style="font-family: 宋体">】月【</span>09<span style="font-family: 宋体">】日</span>
            </p>
            <p style="text-align: center">&nbsp;</p>
            <p style="line-height: 150%">
              <strong><span style="font-family: 宋体">欢迎您使用<span
                    style="text-decoration: underline">创新与知识产权管理人才服务系统（下称</span></span><span
                  style="text-decoration: underline">“</span></strong><strong><span
                  style="text-decoration: underline"><span
                    style="font-family: 宋体">人才服务系统</span>”</span></strong><strong><span
                  style="text-decoration: underline"><span style="font-family: 宋体">）</span></span></strong><strong><span
                  style="font-family: 宋体">的产品和服务。</span></strong>
            </p>
            <p style="line-height: 150%">
              &nbsp;<strong><span style="font-family: 宋体">【重要提示】</span></strong>
            </p>
            <p style="text-indent: 26px; line-height: 150%">
              <strong><span style="font-family: 宋体">《用户服务协议》是您（以下也称</span>“</strong><strong><span
                  style="font-family: 宋体">用户</span>”</strong><strong><span
                  style="font-family: 宋体">）与人才服务系统运营方</span></strong><strong><span
                  style="font-family: 宋体">【</span></strong><strong><span
                  style="line-height: 150%; font-family: 宋体">创新管理标准化国际伙伴计划</span></strong><strong><span
                  style="font-family: 宋体">】之间关于您使用人才服务系统的服务（以下简称“服务”</span></strong><strong><span
                  style="font-family: 宋体">）所涉相关事项的法律协议。在使用人才服务系统运营方提供的各项服务之前，请您仔细阅读、理解《用户服务协议》（简称</span>“</strong><strong><span
                  style="font-family: 宋体">本协议</span>”</strong><strong><span
                  style="font-family: 宋体">），特别是以黑体加粗、下划线标识等其他合理方式提示您注意的可能与您利益有重大关系的条款，包括但不限于相关免除责任的条款、对权利进行限制的条款、法律适用和争议解决条款等。</span></strong>
            </p>
            <p style="text-indent: 26px; line-height: 150%">
              <strong><span
                  style="font-family: 宋体">如果您不同意本协议的任意或全部条款，尤其是前述条款，请立即停止资质申请流程。一旦您通过浏览器打开人才服务系统页面点击确认或事实上使用人才服务系统提供的任意一项服务，均视为您已阅读、理解并同意签署本协议，并自愿接受并遵守本协议的全部约定。</span></strong>
            </p>
            <p style="line-height: 150%">
              <strong>&nbsp;</strong><strong><span style="font-family: 宋体">服务条款的确认和接纳：</span></strong>
            </p>
            <p style="margin-left: 19px; line-height: 150%">
              <strong>1.</strong><strong><span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;&nbsp;&nbsp;
                </span></strong><strong><span
                  style="font-family: 宋体">用户同意本协议的，即视为用户确认自己具有享受本系统服务等相应的权利能力和行为能力，能够独立承担法律责任。</span></strong>
            </p>
            <p style="margin-left: 19px; line-height: 150%">
              2.<span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;&nbsp;&nbsp; </span><span
                style="font-family: 宋体">人才服务系统运营方有权根据需要不时地制定、修改本协议或各类规则，如本协议有任何变更，人才服务系统将在系统中通知公告栏目上刊载公告，通知予用户。<strong>如您不同意变更的内容，您应当于本协议变更生效之日起停止使用本服务，变更事项对您不产生效力；如您在变更事项生效后仍继续使用本服务，则视为您同意变更后的协议。</strong></span>
            </p>
            <p style="margin-left: 19px; line-height: 150%">
              3.<span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;&nbsp;&nbsp; </span><span
                style="font-family: 宋体">人才服务系统运营方保留在中华人民共和国大陆地区施行法律允许的范围内独自决定拒绝服务、清除或编辑内容的权利。</span>
            </p>
            <p style="margin-left: 19px; line-height: 150%">
              4.<span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;&nbsp;&nbsp; </span><strong><span
                  style="font-family: 宋体">用户在享有人才服务系统服务同时，需要对知识产权质量评价人员信息填报真实性负有责任，确保填报信息的真实性。</span></strong>
            </p>
            <h1 style="line-height: 150%">
              <span style="font-size: 16px; line-height: 150%">一、服务内容</span>
            </h1>
            <p style="margin-left: 19px; line-height: 150%">
              1.<span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;&nbsp;&nbsp; </span><span
                style="font-family: 宋体">人才服务系统服务的具体内容由人才服务系统运营方根据实际情况提供。</span>
            </p>
            <p style="margin-left: 19px; line-height: 150%">
              2.<span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;&nbsp;&nbsp; </span><span
                style="font-family: 宋体">与相关网络服务有关的设备（如个人电脑、手机有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费）均应由用户自行负担。</span>
            </p>
            <h1 style="line-height: 150%">
              <span style="font-size: 16px; line-height: 150%">二、服务变更、中断或终止</span>
            </h1>
            <p style="margin-left: 19px; line-height: 150%">
              1.<span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;&nbsp;&nbsp; </span><span
                style="font-family: 宋体">鉴于网络服务的特殊性，用户同意人才服务系统运营方有权随时变更、中断或终止部分或全部的服务（包括收费服务）。<strong>如变更、中断或终止的网络服务属于免费的服务，人才服务系统运营方无需通知用户，也无需对任何用户或任何第三方承担任何责任；如变更、中断或终止的网络服务属于收费的服务，人才服务系统运营方应当在变更、中断或终止之前事先通知用户。</strong></span>
            </p>
            <p style="margin-left: 19px; line-height: 150%">
              <strong>2.</strong><strong><span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;&nbsp;&nbsp;
                </span></strong><strong><span
                  style="font-family: 宋体">人才服务系统运营方需要定期或不定期地对平台或相关的设备进行检修或者维护，如因此类情况而造成所提供的服务在合理时间内的中断，人才服务系统运营方无需为此承担任何责任，但人才服务系统运营方应尽可能事先进行通告。</span></strong>
            </p>
            <p style="margin-left: 19px; line-height: 150%">
              <strong>3.</strong><strong><span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;&nbsp;&nbsp;
                </span></strong><strong><span
                  style="font-family: 宋体">如发生下列任何一种情形，人才服务系统运营方有权随时中断或终止向用户提供本协议项下的服务（包括收费服务）而无需对用户或任何第三方承担任何责任：</span></strong>
            </p>
            <p style="margin-left: 46px; line-height: 150%">
              <strong>3.1 </strong><strong><span style="font-family: 宋体">用户提供的个人资料不真实；</span></strong>
            </p>
            <p style="margin-left: 46px; line-height: 150%">
              <strong>3.2 </strong><strong><span style="font-family: 宋体">用户违反本协议中规定的使用规则。</span></strong>
            </p>
            <p style="margin-left: 19px; line-height: 150%">
              4.<span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;&nbsp;&nbsp; </span><strong><span
                  style="font-family: 宋体">若因用户违反本协议的约定，导致或产生第三方主张的任何索赔、要求或损失，应当自行负责处理由此产生的争议，并承担全部法律责任，若人才服务系统运营方因此遭受损失的，您应当一并赔偿。</span></strong>
            </p>
            <h1 style="line-height: 150%">
              <span style="font-size: 16px; line-height: 150%">三、使用规则</span>
            </h1>
            <p style="margin-left: 19px; line-height: 150%">
              1.<span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;&nbsp;&nbsp; </span><span
                style="font-family: 宋体">用户在申请使用人才服务系统服务时，必须向人才服务系统运营方提供必要、准确的个人及企业资料，如个人及企业资料有任何变动，请务必及时更新。</span>
            </p>
            <p style="margin-left: 19px; line-height: 150%">
              2.<span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;&nbsp;&nbsp; </span><span
                style="font-family: 宋体">用户同意人才服务系统运营方有权在提供网络服务过程中以各种方式投放各种商业性广告或其他任何类型的商业信息（包括但不限于在人才服务系统的任何页面上投放广告），并且，用户同意接受人才服务系统运营方通过电子邮件或其他方式向用户发送商品促销或其他相关商业信息。</span>
            </p>
            <p style="margin-left: 19px; line-height: 150%">
              3.<span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;&nbsp;&nbsp; </span><span
                style="font-family: 宋体">用户在使用人才服务系统网络服务过程中，必须遵循以下原则：</span>
            </p>
            <p style="margin-left: 46px; line-height: 150%">
              3.1
              <span
                style="font-family: 宋体">用户在使用人才服务系统的服务过程中，应遵守宪法法律，包括但不限于《中华人民共和国保守国家秘密法》、《中华人民共和国著作权法》、《中华人民共和国计算机信息系统安全保护条例》、《计算机小程序保护条例》、《互联网电子公告服务管理规定》、《信息网络传播权保护条例》、《网络安全法》等有关计算机及互联网规定的法律、法规；应遵守公共秩序，尊重社会公德，不得危害网络安全，不得利用网络从事危害国家安全、荣誉和利益，煽动颠覆国家政权、推翻社会主义制度，煽动分裂国家、破坏国家统一，宣扬恐怖主义、极端主义，宣扬民族仇恨、民族歧视，传播暴力、淫秽色情信息，编造、传播虚假信息扰乱经济秩序和社会秩序，以及侵害他人名誉、隐私、知识产权和其他合法权益等活动。在任何情况下，人才服务系统一旦合理地认为用户存在上述行为的，可以在任何时候，不经事先通知终止向该用户提供服务；</span>
            </p>
            <p style="margin-left: 46px; line-height: 150%">
              3.2
              <span style="font-family: 宋体">遵守所有与网络服务有关的网络协议、规定和程序；</span>
            </p>
            <p style="margin-left: 46px; line-height: 150%">
              3.3
              <span style="font-family: 宋体">不得为任何非法目的而使用网络服务系统；</span>
            </p>
            <p style="margin-left: 46px; line-height: 150%">
              3.4
              <span style="font-family: 宋体">不得以任何形式使用人才服务系统网络服务侵犯平台的商业利益，包括但不限于发布非经人才服务系统许可的商业广告；</span>
            </p>
            <p style="margin-left: 46px; line-height: 150%">
              3.5
              <span style="font-family: 宋体">不得利用人才服务系统网络服务系统进行任何可能对互联网或移动网正常运转造成不利影响的行为；</span>
            </p>
            <p style="margin-left: 46px; line-height: 150%">
              3.6
              <span style="font-family: 宋体">不得利用人才服务系统提供的网络服务上传、展示或传播任何虚假的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的或其他任何非法信息资料；</span>
            </p>
            <p style="margin-left: 46px; line-height: 150%">
              3.7
              <span style="font-family: 宋体">不得侵犯其他任何第三方的专利权、著作权、商标权、名誉权或其他任何合法权益；</span>
            </p>
            <p style="margin-left: 46px; line-height: 150%">
              3.8
              <span style="font-family: 宋体">不得利用人才服务系统网络服务系统进行任何不利于人才服务系统的行为。</span>
            </p>
            <p style="margin-left: 19px; line-height: 150%">
              4.<span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;&nbsp;&nbsp; </span><span
                style="font-family: 宋体">人才服务系统运营方有权对用户使用人才服务系统服务的情况进行审查和监督。如用户在使用网络服务时违反任何上述规定，人才服务系统运营方或其授权的人有权要求用户改正或直接采取一切必要的措施（包括但不限于更改或删除用户张贴的内容等、暂停或终止用户使用网络服务的权利）以减轻用户不当行为造成的影响。</span>
            </p>
            <p style="margin-left: 19px; line-height: 150%">
              5.<span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;&nbsp;&nbsp; </span><span
                style="font-family: 宋体">人才服务系统运营方针对某些特定的人才服务系统服务的使用通过各种方式做出的任何声明、通知、警示等内容视为本协议的一部分，用户如使用该等人才服务系统网络服务，视为用户同意该等声明、通知、警示的内容。</span>
            </p>
            <p style="margin-left: 19px; line-height: 150%">
              6.<span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;&nbsp;&nbsp; </span><span
                style="font-family: 宋体">凡用户昵称中出现如下信息者（包括但不限于），平台有权进行屏蔽、锁定，甚至注销：</span>
            </p>
            <p style="margin-left: 46px; line-height: 150%">
              6.1
              <span style="font-family: 宋体">使用严重违反国家法律及风俗，包含或暗藏反动、色情等信息（含符号、地址等）的昵称；</span>
            </p>
            <p style="margin-left: 46px; line-height: 150%">
              6.2
              <span style="font-family: 宋体">使用党和国家领导人、古今中外比较有影响的名人、网络上知名人士的真实姓名、字、号、艺名、笔名、头衔等为昵称；</span>
            </p>
            <p style="margin-left: 46px; line-height: 150%">
              6.3
              <span style="font-family: 宋体">使用国家机构、企事业单位、知名公司或品牌的名称及标识为昵称；</span>
            </p>
            <p style="margin-left: 46px; line-height: 150%">
              6.4
              <span style="font-family: 宋体">含性别歧视、种族歧视、地域歧视等信息的昵称；</span>
            </p>
            <p style="margin-left: 46px; line-height: 150%">
              6.5
              <span style="font-family: 宋体">含自侮辱、猥亵或者对他人进行侮辱、挑衅、漫骂、人身攻击等不文明、不健康信息的昵称；</span>
            </p>
            <p style="margin-left: 46px; line-height: 150%">
              6.6
              <span style="font-family: 宋体">含易产生歧义、引起他人误解的信息的昵称；</span>
            </p>
            <p style="margin-left: 46px; line-height: 150%">
              6.7
              <span style="font-family: 宋体">未获得人才服务系统运营方官方正式许可而使用带有人才服务系统名称的昵称；</span>
            </p>
            <p style="margin-left: 46px; line-height: 150%">
              6.8
              <span style="font-family: 宋体">带有明显广告性质的昵称；</span>
            </p>
            <p style="margin-left: 46px; line-height: 150%">
              6.9
              <span style="font-family: 宋体">带有其它法律法规以及论坛禁止规则中所包含信息的昵称。</span>
            </p>
            <p style="margin-left: 19px; line-height: 150%">
              7.<span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;&nbsp;&nbsp; </span><span
                style="font-family: 宋体">用户行为规范</span>
            </p>
            <p style="margin-left: 22px; line-height: 150%">
              <span style="font-family: 宋体">人才服务系统运营方不允许违反法律法规及妨害平台秩序的行为，一经发现相关内容将被取消用户资格。</span>
            </p>
            <p style="margin-left: 46px; line-height: 150%">
              7.1<span style="font-family: 宋体">违反法律法规</span>
            </p>
            <p style="margin-left: 22px; line-height: 150%">
              <span
                style="font-family: 宋体">人才服务系统运营方严格遵守《互联网信息服务管理办法》及相关法律法规，禁止包含以下信息的违法违规内容出现，以下情形中，我们可能会收集使用你的相关个人信息无需征求您的授权同意：</span>
            </p>
            <p style="margin-left: 46px; line-height: 150%">
              7.1.1
              <span style="font-family: 宋体">反对宪法所确定的基本原则的；</span>
            </p>
            <p style="margin-left: 46px; line-height: 150%">
              7.1.2
              <span style="font-family: 宋体">危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</span>
            </p>
            <p style="margin-left: 46px; line-height: 150%">
              7.1.3
              <span style="font-family: 宋体">损害国家荣誉和利益的；</span>
            </p>
            <p style="margin-left: 46px; line-height: 150%">
              7.1.4
              <span style="font-family: 宋体">煽动民族仇恨、民族歧视，破坏民族团结的；</span>
            </p>
            <p style="margin-left: 46px; line-height: 150%">
              7.1.5
              <span style="font-family: 宋体">破坏国家宗教政策，宣扬邪教和封建迷信的；</span>
            </p>
            <p style="margin-left: 46px; line-height: 150%">
              7.1.6
              <span style="font-family: 宋体">散布谣言，扰乱社会秩序，破坏社会稳定的；</span>
            </p>
            <p style="margin-left: 46px; line-height: 150%">
              7.1.7
              <span style="font-family: 宋体">散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</span>
            </p>
            <p style="margin-left: 46px; line-height: 150%">
              7.1.8<span style="font-family: 宋体">侮辱或者诽谤他人，侵害他人合法权益的；</span>
            </p>
            <p style="margin-left: 46px; line-height: 150%">
              7.1.9
              <span style="font-family: 宋体">含有法律、行政法规禁止的其他内容的。</span>
            </p>
            <p style="margin-left: 22px; line-height: 150%">
              <span style="font-family: 宋体">不得使用隐晦表达等方式规避以上限制。</span>
            </p>
            <h1 style="line-height: 150%">
              <span style="font-size: 16px; line-height: 150%">四、知识产权</span>
            </h1>
            <p style="margin-left: 19px; line-height: 150%">
              1.<span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;&nbsp;&nbsp; </span><span
                style="font-family: 宋体">受国际版权公约、中华人民共和国著作权法、专利法、及其他知识产权方面的法律法规的保护，人才服务系统运营方的服务、界面、交互等元素、</span>LOGO<span
                style="font-family: 宋体">、商标、标识、图形、文字、音频、视频、肖像、图片、技术等的所有知识产权归创新管理标准化国际伙伴计划所有和享有。</span>“<span
                style="font-family: 宋体">知识产权</span>”<span
                style="font-family: 宋体">包括在专利法、版权法、商标法、反不正当竞争法中等法律规定的任何和所有权利、任何和所有其它所有权以及其中的任何和所有应用、更新、扩展和恢复。</span>
            </p>
            <p style="margin-left: 19px; line-height: 150%">
              2.<span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;&nbsp;&nbsp; </span><span
                style="font-family: 宋体">人才服务系统运营方为提供网络服务而使用的任何小程序（包括但不限于系统中所含的任何图像、照片、动画、录像、录音、音乐、文字和附加程序、随附的帮助材料）的一切权利均属于人才服务系统运营方，未经创新管理标准化国际伙伴计划的许可，用户不得对该人才服务系统进行反向工程（</span>reverse
              engineer<span style="font-family: 宋体">）、反向编译（</span>decompile<span
                style="font-family: 宋体">）或反汇编（</span>disassemble<span
                style="font-family: 宋体">）。用户不得向任何单位或个人出售、转让、授权人才服务系统的代码、技术接口及开发工具等。</span>
            </p>
            <p style="margin-left: 19px; line-height: 150%">
              3.<span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;&nbsp;&nbsp; </span><span
                style="font-family: 宋体">用户只能在本协议以及人才服务系统运营方明示授权的范围内容使用人才服务系统服务。未经人才服务系统运营方事先书面许可，用户不得以任何营利性或非营利性的目的修改、复制、传播、传送、发行、转移、销售人才服务系统服务所使用的技术、材料以及产品</span>/<span
                style="font-family: 宋体">服务内容等或创造、制作与这些内容有关的派生产品或衍生品。否则，用户自行承担因此而造成对人才服务系统运营方或其他人的全部损害。</span>
            </p>
            <p style="margin-left: 19px; line-height: 150%">
              4.<span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;&nbsp;&nbsp; </span><span
                style="font-family: 宋体">人才服务系统运营方对其自制内容和其他通过授权取得的独占内容（包括但不限于文字、图片、系统架构、测试题目等）享有完全知识产权，未经人才服务系统运营方的许可，任何单位和个人不得私自复制、转载、引用、链接、抓取、传播和提供观看服务或者有其他侵犯人才服务系统知识产权的行为。否则，人才服务系统运营方将追究侵权行为人的法律责任。</span>
            </p>
            <h1 style="line-height: 150%">
              <span style="font-size: 16px; line-height: 150%">五、免责声明</span>
            </h1>
            <p style="margin-left: 19px; line-height: 150%">
              <strong>1.</strong><strong><span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;&nbsp;&nbsp;
                </span></strong><strong><span
                  style="font-family: 宋体">用户明确同意其使用人才服务系统网络服务所存在的风险将完全由其个人承担；因其使用人才服务系统网络服务而产生的一切后果也由其个人承担，人才服务系统运营方对用户不承担任何责任。</span></strong>
            </p>
            <p style="margin-left: 19px; line-height: 150%">
              <strong>2.</strong><strong><span
                  style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;&nbsp;&nbsp;</span></strong><strong><span
                  style="font-family: 宋体">用户明确同意授权人才服务系统运营方查看并使用其个人提交的全部信息资料（包括但不限于：人员姓名、单位名称等）。</span></strong>
            </p>
            <p style="margin-left: 19px; line-height: 150%">
              3.<span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;&nbsp;&nbsp; </span><span
                style="font-family: 宋体">人才服务系统运营方不保证为向用户提供便利而设置的外部链接的准确性和完整性，同时，对于该等外部链接指向的不由人才服务系统运营方实际控制的任何内容，人才服务系统运营方不承担任何责任。</span>
            </p>
            <p style="margin-left: 19px; line-height: 150%">
              4.<span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;&nbsp;&nbsp; </span><span
                style="font-family: 宋体">人才服务系统运营方承诺将不断提升服务质量及服务水平，为用户提供更加优质的服务并对系统进行持续更新。您在进入系统前，清除浏览器缓存或在浏览器中刷新人才服务系统页面，否则人才服务系统运营方并不保证其一定能正常使用。<strong>对于因不可抗力或人才服务系统不能控制的原因造成的网络服务中断或其它缺陷，人才服务系统运营方不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。</strong></span>
            </p>
            <p style="margin-left: 19px; line-height: 150%">
              <strong>5.</strong><strong><span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;&nbsp;&nbsp;
                </span></strong><strong><span
                  style="font-family: 宋体">用户同意，对于人才服务系统运营方向用户提供的下列产品或者服务的质量缺陷本身及其引发的任何损失，以及无论任何原因导致服务中止、终止的，人才服务系统运营方无需承担任何违约、补偿、赔偿责任：</span></strong>
            </p>
            <p style="margin-left: 22px; line-height: 150%">
              <strong>5.1 </strong><strong><span style="font-family: 宋体">人才服务系统运营方向用户免费提供的各项服务；</span></strong>
            </p>
            <p style="margin-left: 22px; line-height: 150%">
              <strong>5.2 </strong><strong><span style="font-family: 宋体">人才服务系统运营方向用户赠送的任何产品或者服务；</span></strong>
            </p>
            <p style="margin-left: 22px; line-height: 150%">
              <strong>5.3 </strong><strong><span style="font-family: 宋体">人才服务系统运营方向收费服务用户附赠的各种产品或者服务。</span></strong>
            </p>
            <p style="margin-left: 19px; line-height: 150%">
              6.<span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;&nbsp;&nbsp; </span><span
                style="font-family: 宋体">其他用户</span>(<span style="font-family: 宋体">或网友</span>)<span
                style="font-family: 宋体">所上传的相片或其他内容，由该用户</span>(<span style="font-family: 宋体">或网友</span>)<span
                style="font-family: 宋体">自行对该提供内容担保其知识性、专业性以及合法性。</span>
            </p>
            <h1 style="line-height: 150%">
              <span style="font-size: 16px; line-height: 150%">六、协议修改</span>
            </h1>
            <p style="margin-left: 19px; line-height: 150%">
              1.<span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;&nbsp;&nbsp; </span><span
                style="font-family: 宋体">人才服务系统运营方有权随时修改本协议的任何条款，一旦本协议的内容发生变动，人才服务系统运营方会直接在人才服务系统上公布修改之后的协议内容，该公布行为视为人才服务系统运营方已经通知用户修改内容。人才服务系统运营方也可通过其他适当方式向用户提示修改内容。</span>
            </p>
            <p style="margin-left: 19px; line-height: 150%">
              2.<span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;&nbsp;&nbsp; </span><span
                style="font-family: 宋体">如果不同意人才服务系统运营方对本协议相关条款所做的修改，用户有权停止使用服务。如果用户继续使用服务，则视为用户接受人才服务系统运营方对本协议相关条款所做的修改。</span>
            </p>
            <h1 style="line-height: 150%">
              <span style="font-size: 16px; line-height: 150%">七、法律管辖</span>
            </h1>
            <p style="margin-left: 19px; line-height: 150%">
              1.<span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;&nbsp;&nbsp; </span><span
                style="font-family: 宋体">本协议的订立、执行和解释及争议的解决均适用中国法律并受人才服务系统运营方所在地人民法院管辖。</span>
            </p>
            <p style="margin-left: 19px; line-height: 150%">
              <strong>2.</strong><strong><span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;&nbsp;&nbsp;
                </span></strong><strong><span
                  style="font-family: 宋体">如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向人才服务系统运营方所在地有管辖权的人民法院提起诉讼。</span></strong>
            </p>
            <h1 style="line-height: 150%">
              <span style="font-size: 16px; line-height: 150%">八、其他规定</span>
            </h1>
            <p style="margin-left: 19px; line-height: 150%">
              1.<span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;&nbsp;&nbsp; </span><span
                style="font-family: 宋体">本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议各方其他权利。</span>
            </p>
            <p style="margin-left: 19px; line-height: 150%">
              2.<span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;&nbsp;&nbsp; </span><span
                style="font-family: 宋体">如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。</span>
            </p>
            <h1 style="line-height: 150%">
              <span style="font-size: 16px; line-height: 150%">九、联系方式</span>
            </h1>
            <p style="margin-left: 22px; line-height: 150%">
              <span style="font-family: 宋体">当您有资质申请相关问题或其他的投诉、建议等，可以通过如下方式与人才服务系统运营方联系。人才服务系统运营方将尽快（</span>15<span
                style="font-family: 宋体">个工作日内）对于您的问题、投诉及建议等进行回复：（工作时间为</span>9:00-17:00<span
                style="font-family: 宋体">，法定节假日除外）</span>
            </p>
            <p style="text-indent: 28px; line-height: 150%">
              <strong><span style="font-size: 16px; line-height: 150%; font-family: 宋体">联系方式如下：</span></strong>
            </p>
            <p style="text-indent: 57px; line-height: 150%">
              <strong><span style="font-size: 16px; line-height: 150%; font-family: 宋体">公共邮箱</span></strong><span
                style="font-size: 16px; line-height: 150%; font-family: 宋体">：</span><span
                style="font-size: 16px; line-height: 150%">info@imspp.org.cn</span>
            </p>
            <p style="text-indent: 57px; line-height: 150%">
              <strong><span style="font-size: 16px; line-height: 150%; font-family: 宋体">联系电话</span></strong><span
                style="font-size: 16px; line-height: 150%; font-family: 宋体">：</span><span
                style="font-size: 16px; line-height: 150%">010-82062112</span>
            </p>
            <p>
              <br />
            </p>
          </div>
        </div>
        <!-- </el-scrollbar> -->
        <div style="margin: 20px 0; text-align: center">
          <el-button class="agreeConsent" type="primary" :disabled="flag" @click="agreeConsent">同意 {{ msg }}</el-button>
        </div>
      </div>

      <div class="teps" v-if="message" v-loading="loading">
        <el-steps :active="active" align-center>
          <el-step title="个人信息"></el-step>
          <el-step title="从业信息"></el-step>
          <el-step title="资质信息"></el-step>
          <el-step title="完成"></el-step>
        </el-steps>

        <PersonalInfor v-show="active == 1" ref="medit" @next="next" :infoMation="infoMation" :activeNum="active"
          :idsession="userInfoid"></PersonalInfor>
        <PracticeInfor v-show="active == 2" @next="next" @prev="prev" :activeNum="active" :infoMation="infoMation"
          :changeId="changeId" :idsession="userInfoid"></PracticeInfor>
        <QualificationInfor v-show="active == 3" @next="next" @submit="submit" @prev="prev" :activeNum="active"
          :flag="1" :idsession="userInfoid"></QualificationInfor>
        <div class="submitInfo" v-show="active == 4" style="text-align: center">
          <img src="@/assets/pass.png" alt="" />
          <p style="font-size: 18px; line-height: 50px"
            v-if="($route.query.status && $route.query.status == 0) && submitflag != 1">
            您的创新管理咨询师申请未审核通过，请<span @click="prev(1)" style="color: #409eff;cursor: pointer;">返回>></span>继续修改。
          </p>
          <p style="font-size: 18px; line-height: 50px" v-else>
            您的游戏主持人申请已提交成功，工作人员会尽快为您审核，审核结果将以短信通知或在人中心-资质申请中查看，谢谢。
          </p>
          <!-- <p style="color: #666">
            有关资质审核结果，请登录<span
              style="color: #409eff"
              @click="goIndex"
              >人员资质管理系统</span
            >
            查询
          </p> -->
        </div>
      </div>

      <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" top="25vh" style="text-align: left"
        :before-close="handleClose">
        <span>我承诺以上所填信息真实有效，提交的材料无任何伪造、修改、虚假成份。如有虚假愿承担相应责任。</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="infoSubmit">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <Foot />
  </div>
</template>

<script>
import PersonalInfor from "@/views/qualificationApplication/components/personalInforSecond.vue";
import PracticeInfor from "@/views/qualificationApplication/components/practiceInforSecond.vue";
import QualificationInfor from "@/views/qualificationApplication/components/qualificationSecond.vue";
import Foot from "@/components/Foot.vue";
import {
  getDictInfoNew,
  getAreaTime,
  userInfo,
  addAptitude,
  preCheck,
  aptitudeUpdata,
  addUnit,
  unitUpdata,
  addcertificate,
  certificateUpdata,
  submitApply
} from "@/api/api.js";

export default {
  name: "",
  components: { Foot, PersonalInfor, PracticeInfor, QualificationInfor },
  props: {},
  data() {
    return {
      region: "", //所属类型
      personalInforData: {}, //个人信息数据
      // 总数据
      totalData: {
        ...this.personalInforData,
        unitList: [], //增加从业经历数据
        certificateList: [], //增加资质数据
        inIndustry: "", //行业分类
        caseNum: "", //案子量
        isIllegal: "", //是否违法
        isUnitAgree: "", //是否
        otherAnnexFileList: [],
      },
      operation1: false,
      message: true,
      active: Number(this.$route.query.operStep) || 1,
      dialogImageUrl: "",
      dialogVisible: false,
      dialogFormVisible: false,
      flag: false,
      timer: null,
      msg: "",
      bannerHeight: "",
      infoMation: {},
      submitdata: {},
      isEdit: "",
      loading: false,
      userInfoid: this.$route.query.userInfos,
      submitflag: 0,
      changeId: ""
    };
  },
  computed: {},
  watch: {
    bannerHeight(val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.bannerHeight = val;
        this.timer = true;
        let that = this;
        setTimeout(function () {
          // 打印screenWidth变化的值
          that.timer = false;
        }, 400);
      }
    },
    active(val) {
      // console.log(val,'1')
      if (val) {
        this.active = val
      } else {
        this.active = 1
      }
    }
  },
  async created() {
    // await this.getInfo();
    var value = sessionStorage.getItem("user");
    if (value != "" && value != undefined) {
      this.getFlag();
    } else {
      sessionStorage.removeItem("index");
      this.$router.push({ name: "Signin" });
    }
    this.bannerHeight = (730 / 2560) * document.body.clientWidth;
  },
  async mounted() {
    const that = this;
    window.onresize = () => {
      return (() => {
        that.bannerHeight = (730 / 2560) * document.body.clientWidth;
      })();
    };
    sessionStorage.removeItem('userInfoid')
  },
  methods: {
    getFlag() {
      if (this.$route.query.status) {
        return
      }
      // 咨询师
      preCheck(this.$qs.stringify({ userType: "2", cerType: '6' })).then((res) => {
        // this.msgInfo = res.msg;
        if (res.code != '1000' && !res.data) {
          // this.dialogVisibleFlag = true;
          this.$store.state.indexActive = 51;
          this.goIndex();
        }
        if (res.data) {
          this.userInfoid = res.data.id
          sessionStorage.setItem('userInfoid', res.data.id)
        }
      });
    },
    agreeConsent() {
      this.operation1 = false;
      this.message = true;
    },
    goIndex() {
      this.$router.push({ name: "index", query: { flag: 2 } });
      sessionStorage.setItem("index", 51);
    },
    prev(active) {
      this.active = active;
      this.getFlag()
    },
    next(active, form, isEdit, flag) {
      // this.getFlag()
      // if (!this.userInfoid) {
      //   this.userInfoid = sessionStorage.getItem('userInfoid')
      // }
      this.loading = true
      if (active == 1) {
        let formdata = new FormData();
        formdata.append("operStep", "1");
        formdata.append("userName", form.userName);
        formdata.append("sex", form.sex);
        formdata.append("idcardType", form.idcardType);
        formdata.append("idcardNum", form.idcardNum);
        formdata.append("mobilePhone", form.mobilePhone);
        formdata.append("email", form.email);
        formdata.append("provinceCode", form.provinceCode);
        formdata.append("province", form.province);
        formdata.append("cityCode", form.cityCode);
        formdata.append("city", form.city);
        formdata.append("countyCode", form.countyCode);
        formdata.append("county", form.county);
        formdata.append("address", form.address);
        formdata.append("userType", 2);
        if (form.annexFile) {
          formdata.append("photos", form.annexFile);
        }

        if (form.id) {
          formdata.append("id", form.id);
          let that = this
          return new Promise(function (resolve, reject) {
            aptitudeUpdata(formdata).then((res) => {
              if (res.code == "1000") {
                if (flag == 1) {
                  that.active = 1;
                  that.$message.success('保存成功')
                } else if (flag == 2) {
                  that.active = 2;
                }
                // that.userInfoid = that.$route.query.userInfos
                that.loading = false
                resolve(res)
              } else {
                that.$message.error(res.msg);
                that.loading = false
              }
            });
          })
        } else {
          let that = this
          return new Promise(function (resolve, reject) {
            addAptitude(formdata).then((res) => {
              if (res.code == "1000") {
                if (flag == 1) {
                  that.active = 1;
                  that.$message.success('保存成功')
                } else if (flag == 2) {
                  that.active = 2;
                }
                that.userInfoid = res.data.id
                sessionStorage.setItem('userInfoid', res.data.id)
                that.changeId = res.data.id
                that.loading = false
                resolve(res)
              } else {
                that.$message.error(res.msg);
                that.loading = false
              }
            });
          })
        }
      } else if (active == 2) {
        console.log(this.userInfoid)
        let formdata = {
          userId: this.userInfoid,
          // aptitudeApplyPersonUnitDtoList: [],
          aptitudeApplyPersonUnitDtoList: form,
        };
        if (isEdit == "1") {
          // 编辑
          let that = this
          return new Promise(function (resolve, reject) {
            unitUpdata(formdata).then((res) => {
              if (res.code == "1000") {
                if (flag == 1) {
                  that.active = 2;
                  that.$message.success('保存成功')
                } else if (flag == 2) {
                  that.active = 3;
                }
                that.loading = false
                resolve(res)
              } else {
                that.$message.error(res.msg);
                that.loading = false
              }
            });
          })
        } else {
          let that = this
          return new Promise(function (resolve, reject) {
            addUnit(formdata).then((res) => {
              if (res.code == "1000") {
                if (flag == 1) {
                  that.active = 2;
                  that.$message.success('保存成功')
                } else if (flag == 2) {
                  that.active = 3;
                }
                that.loading = false
                resolve(res)
              } else {
                that.$message.error(res.msg);
                that.loading = false
              }
            });
          })
        }
      } else if (active == "3") {
        // form.inIndustry
        this.submitdata = form;
        this.isEdit = isEdit;
        this.loading = false
        let that = this
        return new Promise((resolve, reject) => {
          that.submit('2').then(res => {
            resolve(res)
          })
        })
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
    submit(type) {
      console.log("总数据2", this.submitdata);
      const mergedArray = this.submitdata.seletList.concat(this.submitdata.seletList2, this.submitdata.seletList3);
      const mergedArrayfile = this.submitdata.lists.concat(this.submitdata.lists2, this.submitdata.lists3, this.submitdata.lists4, this.submitdata.lists5);
      const delAnnexFileIdList = [...new Set(this.submitdata.delAnnexFileIdList)];

      let formdata = {
        aptitudeApplyPersonCertificateList: [...new Set(mergedArray)],
        userId: this.userInfoid,
        annexFileList: mergedArrayfile,
      }

      this.loading = true
      if (this.isEdit == "1") {
        // 编辑
        formdata.delAnnexFileIdList = delAnnexFileIdList
        let that = this
        return new Promise(function (resolve, reject) {
          // ... some code
          certificateUpdata(formdata).then((res) => {
            // this.dialogVisible = false;
            if (res.code == "1000") {
              // that.active = 4;
              // this.finish()
              if (type) resolve(res)
              that.loading = false
              that.dialogVisible = true;

            } else {
              that.$message.error(res.msg);
              that.loading = false
            }
          });
        })
      } else {
        let that = this
        return new Promise(function (resolve, reject) {
          addcertificate(formdata).then((res) => {
            // this.dialogVisible = false;
            if (res.code == "1000") {
              // this.active = 4;
              // this.finish()
              that.loading = false
              that.dialogVisible = true;
              if (type) resolve(res)
            } else {
              that.$message.error(res.msg);
              that.loading = false
            }
          });
        });
      }
    },
    infoSubmit() {
      this.finish()
    },
    finish() {
      submitApply(this.$qs.stringify({ userId: this.userInfoid })).then(res => {
        if (res.code == '1000') {
          this.active = 4;
          this.dialogVisible = false;
          this.submitflag = 1
        }
      })
    },
    getInfo() {
      if (sessionStorage.getItem("user")) {
        let user = JSON.parse(sessionStorage.getItem("user"));
        userInfo({ id: user.id }).then((res) => {
          this.infoMation = res.data;
        });
      }
    },
  },
};
</script>

<style scoped lang="less">
:v-deep .el-form-item__content {
  text-align: left;
}

.container {
  width: 100%;

  // background: #f0f0f0;
  height: 100%;

  .header {
    padding-top: 120px;
    box-sizing: border-box;
    height: 450px;
    font-size: 40px;
    text-align: left;
    background: url("../../assets/gamebg.png") 100% 100% no-repeat;
    background-size: 100% 100%;
    color: #fff;

    h3 {
      width: 1100px;
      margin: 0 auto;
      margin-bottom: 30px;
      font-weight: normal;
    }
  }

  .postionContainer {
    width: 1200px;
    margin: -60px auto 0 auto;
    background: #fff;
    min-height: calc(100% - 190px);
    margin-bottom: 20px;
    padding: 20px 0;
    border-radius: 15px;
    box-shadow: 1px 2px 1px 1px #f0f0f0;

    .collectProtocol {
      position: relative;
      padding: 20px 60px;
      height: 100%;
      // height: calc(100% - 190px);

      display: flex;
      flex-direction: column;

      .infinite-list {
        // height: 800px;
        // height: calc(100% - 200px);
        height: 800px;
        // flex: 1;
        overflow: auto;
      }

      .protocolTitle {
        font-size: 18px;
        font-weight: 500;
        color: #2b2b2c;
      }

      .protocolContent {
        overflow: auto;
      }

      // .agreeConsent {
      //   height: ;
      // }
    }

    .teps {
      padding: 20px 0px;
    }

    .userInfor {
      margin: 30px 60px;
      border-bottom: 1px solid #f0f0f0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 10px;
      font-size: 15px;

      .btn {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        // text-align: center;
      }
    }
  }
}

.submitInfo {
  margin-top: 50px;
  line-height: 40px;
  font-size: 15px;

  .el-icon-success {
    font-size: 40px;
    color: rgb(46, 214, 46);
  }

  img {
    margin-top: 100px;
  }
}

::v-deep .el-step__title.is-process {
  color: #c0c4cc;
  font-weight: normal;
}

::v-depp .el-step__head.is-wait {
  color: #c0c4cc;
  border-color: #c0c4cc;
  font-weight: normal;
}

::v-deep .el-step__head.is-process {
  color: #c0c4cc;
  border-color: #c0c4cc;
}
</style>
